"use client";

import Breadcrumbs from "@/components/entities/breadcrumbs";
import banner from "../../../../../public/images/header-backgrund-test.gif";
import HeaderBackground from "@/components/ui/header-background";
import { useTranslations } from "next-intl";
import { Container } from "@/components/ui/container";
import S from "./index.module.scss";

const ActualHeader = () => {
  const t = useTranslations();

  const breadcrumbs = [
    { title: t("home"), url: "/" },
    { title: t("news"), url: "/actual" },
  ];

  return (
    <>
      <HeaderBackground src={banner} type="image" />
      <Container>
        <div className={S.headerContent}>
          <Breadcrumbs breadcrumbs={breadcrumbs} />
          <h1 className={S.title}>{t("news")}</h1>
        </div>
      </Container>
    </>
  );
};

export default ActualHeader;
